import type { SVGProps } from 'react';

export const Feedback = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="32px"
    role="img"
    viewBox="0 0 32 32"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'feedback'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <rect height="32" width="32" x="0" y="0" />
      <g transform="translate(0.000000, 1.000048)">
        <g fill={props.fill}>
          <path d="M30.3953787,13.4691913 C30.3953787,19.2471117 25.694801,23.9476893 19.9168806,23.9476893 L14.4932606,23.9476893 L14.4932606,23.9666239 L14.0818357,23.9537869 C14.0750963,23.9797818 13.4162388,26.3992298 11.2063543,27.4987163 C9.99743261,28.1001284 8.6758665,28.3196406 7.70250321,28.3931322 C7.8783697,28.1113607 8.06964056,27.7856226 8.26732991,27.4175225 C9.29557125,25.5025674 9.26893453,23.669448 9.26765083,23.5789474 L8.76636714,23.4213736 L8.771181,23.4082157 C4.48491656,21.9682285 1.60462131,17.9743261 1.60462131,13.4691913 L1.60462131,12.0831194 C1.60462131,6.30519897 6.3055199,1.60462131 12.0831194,1.60462131 L19.9168806,1.60462131 C25.694801,1.60462131 30.3953787,6.30519897 30.3953787,12.0831194 L30.3953787,13.4691913 Z M12.0831194,0 C5.42073171,0 0,5.42041078 0,12.0831194 L0,13.4691913 C0,18.4178434 3.01347882,22.8295892 7.56964056,24.6713736 C7.4563543,25.2779204 7.25417202,26.004172 6.8915276,26.6790757 C6.19929397,27.9682285 5.60141207,28.6710526 5.59691913,28.6765083 L4.59948652,29.8295892 L6.11810013,29.9646983 C6.15372272,29.9682285 6.41912709,29.9900513 6.84178434,29.9900513 C7.91206675,29.9900513 9.98973042,29.8482028 11.9021181,28.8966624 C13.5760591,28.0638639 14.5603338,26.622914 15.0959564,25.5523107 L19.9168806,25.5523107 C26.5792683,25.5523107 32,20.1318999 32,13.4691913 L32,12.0831194 C32,5.42041078 26.5792683,0 19.9168806,0 L12.0831194,0 Z" />
        </g>
        <rect height="32" width="32" x="0" y="-1.000048" />
      </g>
    </g>
  </svg>
);
